import React, { useContext, ReactNode } from 'react';

import isEmpty from 'lodash/isEmpty';

import { Box, Grid, Container } from '@mui/material';

import { DataContext } from '../components/data/DataContext';

import NoData from './NoData';
import Loading from '../components/layout/Loading';
import TopBar from '../components/layout/TopBar';

import { gridSpacing } from '../assets/theme/muitheme';
import { DataContextType } from '../components/data_types/interfaces';

interface ComponentProps {
    children: ReactNode;
}

const RouteWrapper: React.FC<ComponentProps> = ({ children }) => {
    const context = useContext<DataContextType | undefined>(DataContext);
    const { currentSeason, historyData, playerSeasonData, summaryData, playerData } = context || {};

    if (currentSeason === '') {
        return <Loading />;
    }

    if (!playerData || !playerSeasonData || isEmpty(historyData) || isEmpty(summaryData)) {
        return <NoData />;
    }

    return (
        <Container maxWidth="lg">
            <Box sx={{ flexGrow: 1 }}>
                <TopBar />
            </Box>

            <Grid item xs={12}>
                <Grid container spacing={gridSpacing}>
                    {children}
                </Grid>
            </Grid>
        </Container>
    );
};

export default RouteWrapper;
